export const jobSearchStatusesMap = {
  started_interviewing: {
    id: 'started_interviewing',
    label: 'Actively looking and already interviewing',
    deprecated: true,
  },
  open_not_looking: {
    id: 'open_not_looking',
    label: 'Not actively looking but open to new opportunities',
    deprecated: true,
  },
  actively_looking: {
    id: 'actively_looking',
    label: "Yes, I'm looking for a new job and ready to interview",
    deprecated: false,
  },
  ready_to_interview: {
    id: 'ready_to_interview',
    label: "Not actively looking, but I'm ready to interview for interesting positions",
    deprecated: false,
  },
  unsure: {
    id: 'unsure',
    label: "Not sure yet, I'm looking to learn more about my options",
    deprecated: false,
  },
  not_looking: {
    id: 'not_looking',
    label: 'No, I’m not looking to start a job search right now',
    deprecated: false,
  },
}

export const jobSearchStatusesList = Object.values(jobSearchStatusesMap)

export const jobSearchNoticePeriodMap = {
  '0 weeks': {
    value: '0 weeks',
    label: '0 weeks',
  },
  '2 weeks': {
    value: '2 weeks',
    label: '2 weeks',
  },
  '4 weeks': {
    value: '4 weeks',
    label: '4 weeks',
  },
  '8 weeks': {
    value: '8 weeks',
    label: '8 weeks',
  },
  longer_than_8_weeks: {
    value: 'longer_than_8_weeks',
    label: 'Longer than 8 weeks',
  },
}

export const jobSearchNoticePeriodList = Object.values(jobSearchNoticePeriodMap)

export const jobSearchNoticePeriodTypeMap = {
  calendar_month: {
    value: 'calendar_month',
    label: 'Beginning of calendar month',
  },
  date_of_notice: {
    value: 'date_of_notice',
    label: 'From date of notice',
  },
}

export const jobSearchNoticePeriodTypeList = Object.values(jobSearchNoticePeriodTypeMap)

export const jobSearchContractConditionsMap = {
  restraint_of_trade: {
    value: 'restraint_of_trade',
    label: 'Restraint of trade',
  },
  probation_period: {
    value: 'probation_period',
    label: 'Still in probation period',
  },
  bursary_owed: {
    value: 'bursary_owed',
    label: 'Bursary still owed',
  },
  training_owed: {
    value: 'training_owed',
    label: 'Training payback still owed',
  },
  retension_bonus_owed: {
    value: 'retension_bonus_owed',
    label: 'Retention bonus still owed',
  },
  other_payback_owed: {
    value: 'other_payback_owed',
    label: 'Other payback still owed',
  },
  other_conditions: {
    value: 'other_conditions',
    label: 'Other condition(s)',
  },
}

export const jobSearchContractConditionsList = Object.values(jobSearchContractConditionsMap)

export const jobSearchReasonsMap = {
  more_challenge: {
    value: 'more_challenge',
    label: 'More challenges, growth opportunities or responsibilities',
  },
  under_stimulated: {
    value: 'under_stimulated',
    label: 'Feel under-stimulated or bored',
  },
  work_life_balance: {
    value: 'work_life_balance',
    label: 'Better work-life balance',
  },
  culture: {
    value: 'culture',
    label: 'Unhappy with the culture',
  },
  expectations_not_met: {
    value: 'expectations_not_met',
    label: 'Company didn’t meet expectations',
  },
  change_industry_or_company_size: {
    value: 'change_industry_or_company_size',
    label: 'Want a different industry or company size',
  },
  better_remuneration: {
    value: 'better_remuneration',
    label: 'Better salary, benefits or perks',
  },
  retrenchment_or_company_finances: {
    value: 'retrenchment_or_company_finances',
    label: 'Company in financial difficulty or being retrenched',
  },
  not_currently_employed: {
    value: 'not_currently_employed',
    label: 'Unemployed or on a sabbatical',
  },
  currently_freelance: {
    value: 'currently_freelance',
    label: 'Contract is ending or freelancing',
  },
  relocation: {
    value: 'relocation',
    label: 'Relocating or looking to relocate',
  },
  graduation: {
    value: 'graduation',
    label: 'Graduating soon or recently graduated',
  },
  just_browsing: {
    value: 'just_browsing',
    label: 'Just browsing',
  },
  other: {
    value: 'other',
    label: 'Other',
  },
}

export const jobSearchReasonsList = Object.values(jobSearchReasonsMap)
